import { useLocation } from "react-router";

/**
 * True when the search page was reached through a paginated URL (?p=2 and beyond).
 *
 * `useLocation` is the single source of truth on both sides: during SSR the
 * StaticRouter is given `req.url` (path + query), and on the client it reflects the
 * live URL — so the server and the first client render always agree. Non-numeric or
 * out-of-range values (`?p=next`, `?p=0`) resolve to page 1, matching how the search
 * thunk normalises the param.
 */
const useIsPaginatedSearchPage = (): boolean => {
  const { search } = useLocation();
  const p = new URLSearchParams(search).get("p");
  const page = p ? parseInt(p, 10) : 1;

  return !Number.isNaN(page) && page > 1;
};

export default useIsPaginatedSearchPage;
